import { render, staticRenderFns } from "./logsCard.vue?vue&type=template&id=4c2b83bf&"
import script from "./logsCard.vue?vue&type=script&lang=js&"
export * from "./logsCard.vue?vue&type=script&lang=js&"
import style0 from "./logsCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "logsCard.vue"
export default component.exports